var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.ClientService.client
    ? _c(
        "div",
        { staticStyle: { "font-size": "14px", "margin-right": "10px" } },
        [
          _vm._v("\n\tDéjà inscrit ?\n\t"),
          _c(
            "a",
            {
              attrs: { href: "", id: "login-link" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.open()
                },
              },
            },
            [_vm._v("Connectez-vous ici")]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }